import { StyleSheet, View } from 'react-native';
import { useSelector } from 'react-redux';
import { Divider, useTheme } from '@ui-kitten/components';

import FormPaymentMethods from '../../../Components/FormFields/FormPaymentMethods';
import SubmitButton from '../../../Components/FormFields/SubmitButton';
import { textCategory } from '../../../Components/Reservation/constants';
import {
  ids as reservationStyleIds,
  styles as reservationStyles,
} from '../../../Components/Reservation/styles';
import ResponsiveText from '../../../Components/ResponsiveText';
import { selectReservationCheckoutData } from '../../../RTK/utility/selectors';
import themeStyle from '../../../Theme/styles';

import Summary from './Summary';

const SummaryAndPaymentWeb = ({
  onFormikError,
}: {
  onFormikError?: (d: any) => void;
}) => {
  const theme = useTheme();
  const checkoutData = useSelector(selectReservationCheckoutData);

  return (
    <View
      dataSet={{ media: reservationStyleIds.boxContainer }}
      style={[reservationStyles.boxContainer, { top: 20 }]}
    >
      <View
        style={[
          styles.summaryContainer,
          { borderColor: theme['color-info-500'] },
        ]}
      >
        <View style={themeStyle.pageVerticalSpacingMedium}>
          <ResponsiveText
            category={textCategory.HEADING}
            style={themeStyle.bold}
          >
            {checkoutData.storeName}
          </ResponsiveText>
          <ResponsiveText category={textCategory.BODY}>
            {checkoutData.itemName}
          </ResponsiveText>
        </View>
        <Divider style={themeStyle.divider} />
        <Summary
          data={checkoutData}
          isReservation={checkoutData?.isReservation}
        />
      </View>
      <FormPaymentMethods name="payment" status="info" />
      <SubmitButton status="info" text="Place Order" onError={onFormikError} />
    </View>
  );
};

const styles = StyleSheet.create({
  summaryContainer: {
    ...themeStyle.pageVerticalSpacingMedium,
    ...themeStyle.pageHorizontalSpacing,
    ...themeStyle.spacingBottom,
    borderWidth: 2,
    borderRadius: 20,
  },
});

export default SummaryAndPaymentWeb;
